import AxiosConfig from "axiosConfig";
import imageCompression from "browser-image-compression";
/*
  This method is triggered when the checkbox for the project interest is selected.
  If the checkbox is selected then the project interest value is added to the project interest
  If the checkbox is removed then the project interest value is removed from the project interest
*/
export const onProjectInterestDataChange = function (event) {
  if (event.target.checked) {
    this.setState({
      projectInterest: this.state.projectInterest.concat(event.target.value),
    });
  } else {
    let filteredArray = this.state.projectInterest.filter(
      (item) => item !== event.target.value
    );
    this.setState({
      projectInterest: filteredArray,
    });
  }
};

/*
When the text fields data is changed,
the target fields name is used as the state variable name and
the target fields value is used as the state variables value
 */
export const onDataChange = function (event) {
  this.setState({ [event.target.name]: event.target.value });
};

/*
When the checkbox data is changed,
the target fields name is used as the state variable name and
the target fields checked status is used as the state variables value
 */
export const onCheckboxChange = function (event) {
  this.setState({ [event.target.name]: event.target.checked });
};

export const onImageChange = function (event) {
  const imageFile = event.target.files[0];
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  const fileSize = imageFile.size / 1024;
  if (fileSize > 1000) {
    imageCompression(imageFile, options)
      .then((compressedFile) => {
        this.setState({
          profilePicError:
            "Uploaded image is too big in size. Image has been compressed.",
          profilePic: URL.createObjectURL(compressedFile),
          finalImage: compressedFile,
        });
      })
      .catch((error) => {
        this.setState({
          profilePicError: "Uploaded image is too big in size.",
        });
      });
  } else {
    this.setState({
      profilePic: URL.createObjectURL(imageFile),
      finalImage: imageFile,
      profilePicError: "",
    });
  }
};
export const onCoverImageChange = function (event) {
  const imageFile = event.target.files[0];
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  const fileSize = imageFile.size / 1024;
  if (fileSize > 1000) {
    imageCompression(imageFile, options)
      .then((compressedFile) => {
        this.setState({
          coverPicError:
            "Uploaded image is too big in size. Image has been compressed.",
          coverPic: URL.createObjectURL(compressedFile),
          finalCoverImage: compressedFile,
        });
      })
      .catch((error) => {
        this.setState({
          coverPicError: "Uploaded image is too big in size.",
        });
      });
  } else {
    this.setState({
      coverPic: URL.createObjectURL(imageFile),
      finalCoverImage: imageFile,
      coverPicError: "",
    });
  }
};

/*
The method is used to fetch all the project category list from the server
 */
export const getCategory = function (obj) {
  AxiosConfig.get("impactprojects/category/").then((response) => {
    let categories = [];
    for (let index of response.data) {
      categories.push(Object.values(index)[0]);
    }
    obj.setState({ projectCat: categories });
  });
};

/*****************************************************************
            Validations
****************************************************************/

/*
The method will add an error {key:value} pair to the errorMap state value.
If there is an existing key, the value will be updated
 */
function addErrorMap(obj, key, value) {
  let errorMap = obj.state.errorMap;
  errorMap.set(key, value);
  obj.setState({ errorMap: errorMap });
}

/*
The method will remove an error {key:value} pair to the errorMap state value.
Based on the key the value will be removed from the map
 */
function removeErrorMap(obj, key) {
  let errorMap = obj.state.errorMap;
  if (errorMap.has(key)) {
    errorMap.delete(key);
  }
  obj.setState({ errorMap: errorMap });
}

/*
The method will call the 'validate_username' method from the server to validate that the username is unique
 */
export const validateAvailabilityUsername = async function (username, email) {
  const response = await AxiosConfig.post("account/validate_username/", {
    username: username,
    email: email,
  });
  return (await response.data.status) === "Valid username";
};

/*
The method is used to validate that the username entered by the user is unique and is not empty
 */
export const validateUsername = async function () {
  let obj = this;
  if (this.state.username === "") {
    addErrorMap(obj, "usernameError", "Please enter username");
  } else {
    let usernameAvailability = validateAvailabilityUsername(
      this.state.username
    );
    await usernameAvailability.then(function (result) {
      if (result) {
        removeErrorMap(obj, "usernameError");
      } else {
        addErrorMap(obj, "usernameError", "Username already exists");
      }
    });
  }
};

/*
The method is used to check that the password length is more than 6 and
that the password and confirm password match
 */
export const validatePassword = function () {
  if (this.state.password.length < 6) {
    addErrorMap(this, "passwordError", "Password to short");
  } else {
    removeErrorMap(this, "passwordError");
    if (this.state.password !== this.state.confirmPassword) {
      addErrorMap(
        this,
        "confirmPasswordError",
        "Password and confirm password do not match"
      );
    } else {
      removeErrorMap(this, "confirmPasswordError");
    }
  }
};

/*
The method is used to check that user has entered their name/child name
 */
export const validateFullName = function () {
  if (this.state.fullName === "") {
    addErrorMap(this, "fullNameError", "Please enter the name");
  } else {
    removeErrorMap(this, "fullNameError");
  }
};

/*
The method is used to check that user has entered their child date of birth
 */
export const validateChildBirthDate = function () {
  if (this.state.dob === "") {
    addErrorMap(this, "dobError", "Date of birth is mandatory");
  } else {
    let age = calculateAge(this.state.dob);
    if (age > 0 && age <= 13) removeErrorMap(this, "dobError");
    else
      addErrorMap(
        this,
        "dobError",
        "You can only create a child account for children under 13 years old. Please enter a valid date of birth for your child."
      );
  }
};

function calculateAge(dob) {
  const today = new Date();
  const birthDate = new Date(dob);
  let age_now = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age_now--;
  }
  return age_now;
}

export const validateTerms = function () {
  if (this.state.isTermsPrivacy === "" || this.state.isTermsPrivacy === false) {
    addErrorMap(
      this,
      "isTermsPrivacyError",
      "Please accept the terms and the privacy"
    );
  } else {
    removeErrorMap(this, "isTermsPrivacyError");
  }
};

export const validateMinorClause = function () {
  if (this.state.isMinorClause === "" || this.state.isMinorClause === false) {
    addErrorMap(
      this,
      "isMinorClauseError",
      "Please accept the clause for being " +
        "responsible for oversight of minor"
    );
  } else {
    removeErrorMap(this, "isMinorClauseError");
  }
};

export const validateConsentSharing = function () {
  if (
    this.state.isConsentSharing === "" ||
    this.state.isConsentSharing === false
  ) {
    addErrorMap(
      this,
      "isConsentSharingError",
      "Please accept the clause accepting consent for sharing"
    );
  } else {
    removeErrorMap(this, "isConsentSharingError");
  }
};

export const validateConsentFeePay = function () {
  if (this.state.isFeePay === "" || this.state.isFeePay === false) {
    addErrorMap(
      this,
      "isFeePayError",
      "Please accept the clause accepting to pay a nominal fee of $1.00 per child"
    );
  } else {
    removeErrorMap(this, "isFeePayError");
  }
};
/*****************************************************************
            Creating Child Validation and Axios Call
****************************************************************/

/*
This method is bound by the object in the calling function
 */
export const addChildDetails = function (condition) {
  let obj = this;
  childValidate(obj).then(function () {
    if (obj.state.errorMap.size !== 0) {
      obj.setState({ pageError: "Resolve the errors to continue" });
    } else {
      //This method will be defined in the calling/base class.
      // obj.createChildAxiosCall(condition);
      obj.triggerStripeClick();
    }
  });
};

export const createChildFormData = function (obj) {
  let formData = new FormData();
  var date = new Date(obj.state.dob),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  let finalDate = [date.getFullYear(), mnth, day].join("-");

  if (obj.state.finalImage)
    formData.append(
      "profile_pic",
      obj.state.finalImage,
      obj.state.finalImage.name
    );
  if (obj.state.finalCoverImage)
    formData.append(
      "cover_pic",
      obj.state.finalCoverImage,
      obj.state.finalCoverImage.name
    );
  formData.append("full_name", obj.state.fullName);
  formData.append("username", obj.state.username);
  formData.append("password", obj.state.password);
  formData.append("dob", finalDate);
  formData.append("gender", obj.state.gender);
  formData.append("school", obj.state.school);
  formData.append("school_grade", obj.state.schoolGrade);
  formData.append("is_checked_tnc", true);
  formData.append("is_checked_privacy", true);
  formData.append("is_minor_clause", true);
  formData.append("is_consent_sharing", true);

  return formData;
};

export const childValidate = async function (obj) {
  obj.setState({ pageError: "" });
  await validateUsername
    .bind(obj)()
    .then(function () {
      validatePassword.bind(obj)();
      validateFullName.bind(obj)();
      validateChildBirthDate.bind(obj)();
      validateTerms.bind(obj)();
      validateMinorClause.bind(obj)();
      validateConsentSharing.bind(obj)();
      validateConsentFeePay.bind(obj)();
    });
};

/*
The method is used to check that user has entered a valid date of birth
 */
export const validateUserBirthDate = function () {
  if (this.state.dob === "") {
    addErrorMap(this, "dobError", "Date of birth is mandatory");
  } else {
    let age = calculateAge(this.state.dob);
    if (age > 18) removeErrorMap(this, "dobError");
    else addErrorMap(this, "dobError", "You are below 18 years");
  }
};

/*
The method is used to check that user (13 to 17 years old) has entered a valid date of birth
 */
export const validateTeenBirthDate = function () {
  if (this.state.dob === "") {
    addErrorMap(this, "dobError", "Date of birth is mandatory");
  } else {
    let age = calculateAge(this.state.dob);
    if (age < 18 && age >= 13) removeErrorMap(this, "dobError");
    else addErrorMap(this, "dobError", "Please enter a valid date of birth");
  }
};

/*
The method is used to check that user has entered a valid mobile number
 */
export const validateMobileNumber = function () {
  const { mobile } = this.state;
  const mobileRegex = /^\d{10}$/;
  if (mobile !== "" && !mobile.match(mobileRegex)) {
    addErrorMap(
      this,
      "mobError",
      "Please enter a valid mobile number in a 10-digit format without symbols: xxxxxxxxxx"
    );
  } else {
    removeErrorMap(this, "mobError");
  }
};

/*
The method is used to validate date of birth on sign up
 */
export const validateDobSignUp = function () {
  const { dob } = this.state;
  if (dob === "") {
    addErrorMap(this, "dobError", "Date of birth is mandatory");
  } else {
    let age = calculateAge(this.state.dob);
    if (age >= 18) {
      removeErrorMap(this, "dobError");
      this.setState({ is_above_eighteen: true });
    } else if (age < 18 && age >= 13) {
      removeErrorMap(this, "dobError");
      this.setState({ is_above_eighteen: false });
    } else if (isNaN(age)) {
      addErrorMap(
        this,
        "dobError",
        "Please enter date in MM/DD/YYYY format, including slash."
      );
    } else {
      addErrorMap(
        this,
        "dobError",
        "You are not eligible to create an individual account \n You must enroll for"
      );
    }
  }
};
